

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATEREFERRALSSECTIONFORREAPPROVAL
// UPDATEREFERRALSSECTIONFORREAPPROVAL


const UPDATEREFERRALSSECTIONFORREAPPROVAL= createAsyncThunk(
  "updateReferralSectionForReApproval/updateReferralSectionForReApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateReferralSectionForReApprovalSlice = createSlice({
  name: "updateReferralSectionForReApprovalSlice",
  initialState: {
    updateReferralSectionForReApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateReferralSectionForReApproval: (state) => {
        state.updateReferralSectionForReApproval.loading = false
        state.updateReferralSectionForReApproval.error = false
        state.updateReferralSectionForReApproval.data = []
        state.updateReferralSectionForReApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEREFERRALSSECTIONFORREAPPROVAL.fulfilled, (state, action) => {
      state.updateReferralSectionForReApproval = {
        ...state.updateReferralSectionForReApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEREFERRALSSECTIONFORREAPPROVAL.pending, (state, action) => {
      state.updateReferralSectionForReApproval = {
        ...state.updateReferralSectionForReApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEREFERRALSSECTIONFORREAPPROVAL.rejected, (state, action) => {
      state.updateReferralSectionForReApproval = {
        ...state.updateReferralSectionForReApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateReferralSectionForReApprovalAction = {
    UPDATEREFERRALSSECTIONFORREAPPROVAL,
};

export { updateReferralSectionForReApprovalAction };
export default updateReferralSectionForReApprovalSlice.reducer;
export const {setInitialStateOfupdateReferralSectionForReApproval} = updateReferralSectionForReApprovalSlice.actions
